export default function Footer() {
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer id="footer" className="bg-foreground-950 text-foreground-300">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          {/* Brand */}
          <div>
            <span className="text-2xl font-bold text-white mb-4 block" style={{ fontFamily: "var(--font-heading)" }}>
              桃子视频
            </span>
            <p className="text-xs text-foreground-400 leading-relaxed mb-4">
              聚合香蕉视频、西瓜视频、蜜桃视频、樱桃视频等水果品牌影视资源，免费高清在线观看电影、电视剧、综艺、动漫，更新快不缓冲。
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 rounded-lg flex items-center justify-center bg-foreground-800 text-foreground-300 hover:bg-primary-500 hover:text-white transition-colors cursor-pointer">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-lg flex items-center justify-center bg-foreground-800 text-foreground-300 hover:bg-primary-500 hover:text-white transition-colors cursor-pointer">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-lg flex items-center justify-center bg-foreground-800 text-foreground-300 hover:bg-primary-500 hover:text-white transition-colors cursor-pointer">
                <i className="ri-bilibili-line text-sm"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-sm font-semibold text-white mb-4">快速导航</h4>
            <ul className="space-y-2">
              <li><a href="#hero" onClick={(e) => handleNavClick(e, '#hero')} className="text-xs text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">首页</a></li>
              <li><a href="#index" onClick={(e) => handleNavClick(e, '#index')} className="text-xs text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">专题合集</a></li>
              <li><a href="#cards" onClick={(e) => handleNavClick(e, '#cards')} className="text-xs text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">精选推荐</a></li>
              <li><a href="#ranking" onClick={(e) => handleNavClick(e, '#ranking')} className="text-xs text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">热度榜单</a></li>
              <li><a href="#faq" onClick={(e) => handleNavClick(e, '#faq')} className="text-xs text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">常见问题</a></li>
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h4 className="text-sm font-semibold text-white mb-4">内容分类</h4>
            <ul className="space-y-2">
              <li><span className="text-xs text-foreground-400 cursor-pointer hover:text-primary-400 transition-colors">热门电影</span></li>
              <li><span className="text-xs text-foreground-400 cursor-pointer hover:text-primary-400 transition-colors">电视剧集</span></li>
              <li><span className="text-xs text-foreground-400 cursor-pointer hover:text-primary-400 transition-colors">综艺节目</span></li>
              <li><span className="text-xs text-foreground-400 cursor-pointer hover:text-primary-400 transition-colors">动漫番剧</span></li>
              <li><span className="text-xs text-foreground-400 cursor-pointer hover:text-primary-400 transition-colors">纪录片</span></li>
            </ul>
          </div>

          {/* Partners */}
          <div>
            <h4 className="text-sm font-semibold text-white mb-4">合作伙伴</h4>
            <p className="text-xs text-foreground-500 leading-relaxed">
              桃子视频聚合以下水果品牌影视资源，为影迷提供一站式的丰富观影选择。
            </p>
            <div className="flex flex-wrap gap-2 mt-3">
              <span className="text-xs text-foreground-500 bg-foreground-800 px-2 py-1 rounded-md whitespace-nowrap">香蕉视频</span>
              <span className="text-xs text-foreground-500 bg-foreground-800 px-2 py-1 rounded-md whitespace-nowrap">西瓜视频</span>
              <span className="text-xs text-foreground-500 bg-foreground-800 px-2 py-1 rounded-md whitespace-nowrap">蜜桃视频</span>
              <span className="text-xs text-foreground-500 bg-foreground-800 px-2 py-1 rounded-md whitespace-nowrap">樱桃视频</span>
              <span className="text-xs text-foreground-500 bg-foreground-800 px-2 py-1 rounded-md whitespace-nowrap">芒果视频</span>
              <span className="text-xs text-foreground-500 bg-foreground-800 px-2 py-1 rounded-md whitespace-nowrap">蓝莓视频</span>
              <span className="text-xs text-foreground-500 bg-foreground-800 px-2 py-1 rounded-md whitespace-nowrap">草莓视频</span>
              <span className="text-xs text-foreground-500 bg-foreground-800 px-2 py-1 rounded-md whitespace-nowrap">柠檬视频</span>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-foreground-800 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; 2026 桃子视频 - 高清影视在线观看平台。本站内容聚合自各水果品牌平台，仅供学习交流。
          </p>
          <div className="flex items-center gap-4">
            <span className="text-xs text-foreground-500 cursor-pointer hover:text-foreground-300 transition-colors">隐私政策</span>
            <span className="text-xs text-foreground-500 cursor-pointer hover:text-foreground-300 transition-colors">使用条款</span>
            <a href="#contact" onClick={(e) => handleNavClick(e, '#contact')} className="text-xs text-foreground-500 cursor-pointer hover:text-primary-400 transition-colors">联系我们</a>
          </div>
        </div>
      </div>
    </footer>
  );
}